import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Input from '@Components/Input';
import Button from '@Components/Button';
import classnames from 'classnames';
import { molecularModalReducerKey } from '../MolecularModalConstants';
import { updateStateParams, dispatchCloseMolecularModal } from '../MolecularModalActions';

function Header({ getCursorPosition, inputRef, updateStringTypeDataValue }) {
  const { formulaText } = useSelector((state) => state.get(molecularModalReducerKey));
  const dispatch = useDispatch();
  const [isTextBoxFocused, setTextBoxFocus] = useState(false);
  const trimmedName = formulaText.trim();
  return (
    <div className="rx-formula__header clearfix">
      <div className="col-sm-8">
        <div className="els-text-input rx-formula__query medium">
          <Input
            clearButton
            id="rx-formula-query-input"
            ref={inputRef}
            name="name"
            type="text"
            className={classnames({ inactive: !isTextBoxFocused && trimmedName.length === 0 })}
            classNameInput="e2e-molecular-formula"
            animatedPlaceholder
            placeholder="Molecular formula:"
            value={formulaText || ''}
            onChange={(value) => {
              dispatch(updateStateParams({ formulaText: value }));
              setTextBoxFocus(true);
            }}
            onBlur={(e) => {
              getCursorPosition(e.target.selectionStart, e.target.selectionEnd);
              setTextBoxFocus(false);
            }}
            onMouseDown={() => {
              setTextBoxFocus(true);
            }}
            debounceDelay={0}
            tabindex="0"
          />
        </div>
      </div>
      <div className="col-sm-4">
        <Button
          type="submit"
          name="use-this-formula"
          // eslint-disable-next-line jsx-a11y/tabindex-no-positive
          tabIndex="1"
          aria-label="Use this formula"
          onClick={() => {
            updateStringTypeDataValue(formulaText);
            dispatchCloseMolecularModal();
          }}
          buttonConfig={{
            type: 'primary',
            size: 'md',
            label: 'Use this formula',
            e2eName: 'molecular-modal-use-formula',
          }}
          iconConfig={{ name: 'chevron-right' }}
          disabled={trimmedName === ''}
        />
      </div>
    </div>
  );
}

Header.defaultProps = {
  getCursorPosition: () => {},
  updateStringTypeDataValue: () => {},
};
Header.propTypes = {
  getCursorPosition: PropTypes.func,
  inputRef: PropTypes.any,
  updateStringTypeDataValue: PropTypes.func,
};

export default Header;
